export default __webpack_public_path__ + "images/77f838742383af6a5c59e7d69ecf633d.png";